<template>
  <div class="invoice-list">
    <el-page-header content="发票列表" class="page-header" />
    <el-card>
      <el-button type="primary" icon="el-icon-plus" @click="$router.push('/create')">新建发票</el-button>
      <el-table :data="list" row-key="id" style="margin-top:16px; width:100%" v-loading="loading">
        <el-table-column prop="invoice_number" label="订单编号" width="100" />
        <el-table-column prop="company_name" label="公司" width="180" />
        <el-table-column label="客户" width="180">
          <template slot-scope="scope">
            <div class="customer-cell">{{ scope.row.shipping_name || '-' }}</div>
            <div class="customer-email">{{ scope.row.shipping_email || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="产品" min-width="160">
          <template slot-scope="scope">
            <div class="product-cell">
              <img v-if="firstItem(scope.row)?.product_logo" :src="fullImageUrl(firstItem(scope.row).product_logo)" class="product-thumb" />
              <span v-else class="product-placeholder">无图</span>
              <span class="product-name">{{ firstItem(scope.row)?.product_name || '-' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="grand_total" label="总计" width="90">
          <template slot-scope="scope">${{ (parseFloat(scope.row.grand_total) || parseFloat(scope.row.amount) || 0).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'warning'" size="small">
              {{ scope.row.status === 1 ? '已完成' : '草稿' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="$router.push(`/create/${scope.row.id}`)">编辑</el-button>
            <el-button type="text" size="small" style="color:#f56c6c" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import invoiceApi from '@/api/invoice'
import { API_BASE_URL } from '@/config'

export default {
  name: 'InvoiceList',
  data() {
    return { list: [], loading: false }
  },
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await invoiceApi.list()
        const data = res.data
        const arr = Array.isArray(data) ? data : []
        this.$set(this, 'list', arr)
      } catch (e) {
        this.$message.error('加载失败: ' + (e.message || ''))
      } finally {
        this.loading = false
      }
    },
    fullImageUrl(url) {
      if (!url) return ''
      if (url.startsWith('http')) return url
      const base = API_BASE_URL || ''
      const path = url.startsWith('/') ? url.slice(1) : url
      if (path.startsWith('uploads/')) {
        return base ? `${base}/upload?action=serve&path=${encodeURIComponent(path)}` : url
      }
      return base ? base + '/' + path : '/' + path
    },
    firstItem(row) {
      const items = row.items || []
      return items[0] || null
    },
    handleDelete(row) {
      this.$confirm('确定删除该发票？', '提示', {
        type: 'warning'
      }).then(async () => {
        await invoiceApi.delete(row.id)
        this.$message.success('已删除')
        this.load()
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.invoice-list { padding: 24px; width: 100%; max-width: 100%; }
.invoice-list .el-card { width: 100%; }
.page-header { margin-bottom: 20px; }
.customer-cell { font-weight: 500; }
.customer-email { font-size: 12px; color: #909399; margin-top: 2px; }
.product-cell { display: flex; align-items: center; gap: 8px; }
.product-thumb { width: 36px; height: 36px; object-fit: contain; border-radius: 4px; }
.product-placeholder { width: 36px; height: 36px; background: #f5f7fa; border-radius: 4px; display: inline-flex; align-items: center; justify-content: center; font-size: 11px; color: #909399; }
.product-name { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 13px; }
</style>
